// @ts-nocheck
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../runtime/json/scalar";
import { default as serialize, } from "../runtime/wire/serialize";
import { tsValueToWireValueFns, unpackFns, } from "../runtime/wire/scalar";
import { default as deserialize, } from "../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        value: [],
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    result.value = value.value.map(value => tsValueToJsonValueFns.uint64(value));
    return result;
}
export function decodeJson(value) {
    var _a, _b;
    const result = getDefaultValue();
    result.value = (_b = (_a = value.value) === null || _a === void 0 ? void 0 : _a.map((value) => jsonValueToTsValueFns.uint64(value))) !== null && _b !== void 0 ? _b : [];
    return result;
}
export function encodeBinary(value) {
    const result = [];
    for (const tsValue of value.value) {
        result.push([1, tsValueToWireValueFns.uint64(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    collection: {
        const wireValues = wireMessage.filter(([fieldNumber]) => fieldNumber === 1).map(([, wireValue]) => wireValue);
        const value = Array.from(unpackFns.uint64(wireValues));
        if (!value.length)
            break collection;
        result.value = value;
    }
    return result;
}
